import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import QRCodeStyling from "qr-code-styling";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";

export class CollectionPage extends BD_Component {
    constructor() {
        super();

        this.id = "collection";
        this.template = "collection-template";

        this.elms = {
            filterToggle: ".js-filter-toggle",
            filterClose: ".js-filter-close",
            filterDropdownWrapper: "#filter-dropdown-wrapper",
            departmentFilters: "#department-filters",
            rarityFilters: "#rarity-filters",
            applyFiltersBtn: ".js-filter-apply",
            resetFiltersBtn: ".js-filter-reset",
            collectionGrid: ".card-collection__grid",
            collectionCard: ".card-collection__card",
            searchInput: ".card-collection__search-input",
            cardDetailPopup: "#card-detail-popup",
            cardDetailCloseBtn: ".js-card-detail-close",
            cardDetailCard: "#card-detail-card",
            cardDetailDepartment: "#card-detail-department",
            cardDetailAvatar: "#card-detail-avatar",
            cardDetailName: "#card-detail-name",
            cardDetailRole: "#card-detail-role",
            cardDetailExperience: "#card-detail-experience",
            cardDetailExperienceLabel: "#card-detail-experience-label",
            cardDetailExperienceAction: ".js-card-detail-experience",
            cardDetailDescriptionOverlay: "#card-detail-description-overlay",
            cardDetailDescriptionClose: ".js-description-close",
            cardDetailDescriptionFull: "#card-detail-description-full",
            cardDetailFlipCard: "#card-detail-flip-card",
            cardDetailBackBtn: ".js-card-detail-back",
            cardDetailTradeBtn: ".js-card-detail-trade",
            cardDetailContinueBtn: ".js-card-detail-continue",
            cardDetailMiniCard: "#card-detail-mini-card",
            cardDetailMiniAvatar: "#card-detail-mini-avatar",
            cardDetailMiniFirstname: "#card-detail-mini-firstname",
            cardDetailMiniLastname: "#card-detail-mini-lastname",
            cardDetailMiniDept: "#card-detail-mini-dept",
            cardDetailMiniRole: "#card-detail-mini-role",
            cardDetailQrCode: ".card-detail-popup__qr-code",
            pagination: ".card-collection__pagination",
            paginationBtn:
                ".card-collection__pagination [data-pagination-action]",
            paginationFirst: '[data-pagination-action="first"]',
            paginationPrev: '[data-pagination-action="prev"]',
            paginationNext: '[data-pagination-action="next"]',
            paginationLast: '[data-pagination-action="last"]',
            paginationDisabledClass:
                "card-collection__pagination-btn--disabled",
            // Select Trade Popup
            selectTradePopup: "#select-trade-popup",
            selectTradeClose: "#select-trade-close",
            selectTradeFilterWrapper: "#select-trade-filter-wrapper",
            selectTradeFilterToggle: ".js-trade-filter-toggle",
            selectTradeFilterClose: ".js-trade-filter-close",
            selectTradeFilterBackdrop: ".js-trade-filter-backdrop",
            selectTradeFilterApply: ".js-trade-filter-apply",
            selectTradeFilterReset: ".js-trade-filter-reset",
            selectTradeSearchInput: ".js-trade-search-input",
            selectTradeGrid: "#select-trade-grid",
            selectTradeDepartmentFilters: "#select-trade-department-filters",
            selectTradeRarityFilters: "#select-trade-rarity-filters",
            selectTradePagination:
                "#select-trade-popup .select-colleague__pagination",
            selectTradePaginationBtn:
                "#select-trade-popup [data-pagination-action]",
            selectTradePaginationDisabledClass:
                "select-colleague__pagination-btn--disabled",
            selectTradeCard: ".js-trade-card",
            selectTradeConfirm: "#select-trade-confirm",
            // Trade Confirm Popup
            tradeConfirmPopup: "#trade-confirm-popup",
            tradeConfirmTitle: "#trade-confirm-title",
            tradeConfirmCancel: "#trade-confirm-cancel",
            tradeConfirmAccept: "#trade-confirm-accept",
            // Trade Success Popup
            tradeSuccessPopup: "#trade-success-popup",
            tradeSuccessOk: "#trade-success-ok",
            // Trade Success Mini Cards
            tradeSuccessReceivedCard: "#trade-success-received-card",
            tradeSuccessReceivedAvatar: "#trade-success-received-avatar",
            tradeSuccessReceivedFirstname: "#trade-success-received-firstname",
            tradeSuccessReceivedLastname: "#trade-success-received-lastname",
            tradeSuccessReceivedDept: "#trade-success-received-dept",
            tradeSuccessReceivedRole: "#trade-success-received-role",
            tradeSuccessGivenCard: "#trade-success-given-card",
            tradeSuccessGivenAvatar: "#trade-success-given-avatar",
            tradeSuccessGivenFirstname: "#trade-success-given-firstname",
            tradeSuccessGivenLastname: "#trade-success-given-lastname",
            tradeSuccessGivenDept: "#trade-success-given-dept",
            tradeSuccessGivenRole: "#trade-success-given-role",
            // Check and achievement animation popups (post-trade flow)
            checkAnimationPopup: ".js-check-animation-popup",
            checkContinueBtn: ".js-check-animation-popup .js-continue",
            achievementAnimationPopup: ".js-achievement-animation-popup",
            achievementContinueBtn: ".js-achievement-animation-popup .js-continue",
            achievementImg: ".js-achievement-animation-popup .js-achievement-img",
            achievementTitle: ".js-achievement-animation-popup .js-achievement-title",
            achievementSubtitle: ".js-achievement-animation-popup .js-achievement-subtitle",
            achievementPoints: ".js-achievement-animation-popup .js-achievement-points",
            // Snackbar Info
            snackbarInfoWrapper: "#snackbar-info-wrapper",
            snackbarInfoClose: "#snackbar-info-close",
            snackbarInfoText: "#snackbar-info-text",
        };
        this.currentColleague = null;
        this.selectedTradeCard = null;
        this._events = this.getEvents();

        this.userId = 0;
        this.tradeId = 0;
        this.initiatorId = 0;
        this.lastTradeResult = null;
        this.tradeAchievementIndex = 0;

        this.filterDepartmentIds = [];
        this.filterRarityIds = [];
        this.searchQuery = "";
        this.searchDebounceTimer = null;
        this.SEARCH_DEBOUNCE_DELAY = 300; // milliseconds
        this.currentPage = 1;
        this.perPage = 10;
        this.pagination = null;

        this.tradeSearchQuery = "";
        this.tradeFilterDepartmentIds = [];
        this.tradeFilterRarityIds = [];
        this.tradeCurrentPage = 1;
        this.tradePagination = null;
        this.tradeSearchDebounceTimer = null;

        this.qrCodeInstance = null;
        this.qrUpdateInterval = null;
        this.QR_UPDATE_INTERVAL_MS = 5 * 60 * 1000;
    }

    /** Duration (ms) for content fade when switching to next achievement. */
    static ACHIEVEMENT_SWITCH_DURATION_MS = 250;
    /** Duration (ms) for crossfade between popups. Must match popup CSS transition. */
    static POPUP_TRANSITION_MS = 300;

    getEvents() {
        const elms = this.elms;

        return [
            {
                event: "click",
                selector: elms.filterToggle,
                handler: this.onFilterToggle,
            },
            {
                event: "click",
                selector: elms.filterClose,
                handler: this.onFilterToggle,
            },
            {
                event: "click",
                selector: elms.applyFiltersBtn,
                handler: this.onApplyFilters,
            },
            {
                event: "click",
                selector: elms.resetFiltersBtn,
                handler: this.onResetFilters,
            },
            {
                event: "input",
                selector: elms.searchInput,
                handler: this.onSearchInput,
            },
            {
                event: "click",
                selector: elms.collectionCard,
                handler: this.onOpenColleagueDetailPopup,
            },
            {
                event: "click",
                selector: elms.cardDetailCloseBtn,
                handler: this.toggleCardDetailPopup,
            },
            {
                event: "click",
                selector: elms.cardDetailBackBtn,
                handler: this.onBackButtonClick,
            },
            {
                event: "click",
                selector: elms.cardDetailTradeBtn,
                handler: this.flipCardToQr,
            },
            {
                event: "click",
                selector: elms.cardDetailContinueBtn,
                handler: this.checkTradeStatus,
            },
            {
                event: "click",
                selector: elms.cardDetailExperienceAction,
                handler: this.onToggleCardDetailDescription,
            },
            {
                event: "click",
                selector: elms.cardDetailDescriptionClose,
                handler: this.onToggleCardDetailDescription,
            },
            {
                event: "click",
                selector: elms.paginationBtn,
                handler: this.onPaginationClick,
            },
            {
                event: "click",
                selector: elms.selectTradePaginationBtn,
                handler: this.onTradePaginationClick,
            },
            // Select Trade Popup Events
            {
                event: "click",
                selector: elms.selectTradeClose,
                handler: this.toggleSelectTradePopup,
            },
            {
                event: "click",
                selector: elms.selectTradeFilterToggle,
                handler: this.toggleSelectTradeFilter,
            },
            {
                event: "click",
                selector: elms.selectTradeFilterClose,
                handler: this.toggleSelectTradeFilter,
            },
            {
                event: "click",
                selector: elms.selectTradeFilterBackdrop,
                handler: this.toggleSelectTradeFilter,
            },
            {
                event: "click",
                selector: elms.selectTradeFilterApply,
                handler: this.onApplyTradeFilters,
            },
            {
                event: "click",
                selector: elms.selectTradeFilterReset,
                handler: this.onResetTradeFilters,
            },
            {
                event: "input",
                selector: elms.selectTradeSearchInput,
                handler: this.onTradeSearchInput,
            },
            {
                event: "click",
                selector: elms.selectTradeCard,
                handler: this.onSelectTradeCard,
            },
            {
                event: "click",
                selector: elms.selectTradeConfirm,
                handler: this.showTradeConfirm,
            },
            {
                event: "click",
                selector: elms.tradeConfirmCancel,
                handler: this.hideTradeConfirm,
            },
            {
                event: "click",
                selector: elms.tradeConfirmAccept,
                handler: this.confirmTrade,
            },
            {
                event: "click",
                selector: elms.tradeSuccessOk,
                handler: this.onTradeSuccessOk,
            },
            {
                event: "click",
                selector: elms.checkContinueBtn,
                handler: this.onTradeCheckContinue,
            },
            {
                event: "click",
                selector: elms.achievementContinueBtn,
                handler: this.onTradeAchievementContinue,
            },
            // Snackbar Info
            {
                event: "click",
                selector: elms.snackbarInfoClose,
                handler: this.toggleSnackbarInfo,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    async render() {
        const collection = await this.fetchCollection();
        this._data.collection = collection.collection;
        this._data.stats = collection.stats;
        this._data.pagination = collection.pagination;
        this._data.departments = CONFIG.game.departments;
        this._data.rarity_levels = CONFIG.game.rarity_levels;
        this.pagination = collection.pagination;
        const data = this._data;
        this.userId = data.user_profile.user_id;

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
        this.updatePaginationState();
        this.openTradePopupFromUrlParams();
        this.setTradeCardCooldown();
    }

    /**
     * Attach cooldown timers to trade cards that have the on-cooldown class.
     * When each timer expires, removes on-cooldown and disabled from the card.
     */
    setTradeCardCooldown() {
        const elms = this.elms;
        const $tradeCards = $(elms.selectTradeCard);
        const coolDownDuration = this._data.cool_down_duration;

        if (!coolDownDuration) return;

        $tradeCards.each(function () {
            const $this = $(this);
            const isOnCoolDown = $this.hasClass("on-cooldown");

            const existingTimer = $this.data("cooldown-timer");
            if (existingTimer) {
                clearInterval(existingTimer);
                $this.removeData("cooldown-timer");
            }

            if (isOnCoolDown) {
                const cooldownAt = $this.data("cooldown-at");
                const cooldownStartTime = new Date(cooldownAt * 1000);
                const cooldownEndTime = new Date(
                    cooldownStartTime.getTime() +
                    coolDownDuration * 60 * 60 * 1000,
                );
                const cooldownCardTimerText = $this.find(
                    ".js-cooldown-card-timer-text",
                );

                const updateTimer = function () {
                    const now = new Date();
                    const timeDiff = cooldownEndTime.getTime() - now.getTime();

                    if (timeDiff <= 0) {
                        cooldownCardTimerText.text("00:00:00");
                        const timerInterval = $this.data("cooldown-timer");
                        if (timerInterval) {
                            clearInterval(timerInterval);
                            $this.removeData("cooldown-timer");
                        }
                        $this.removeClass("on-cooldown disabled");
                        return;
                    }

                    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
                    const minutes = Math.floor(
                        (timeDiff % (1000 * 60 * 60)) / (1000 * 60),
                    );
                    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
                    const hoursStr = String(hours).padStart(2, "0");
                    const minutesStr = String(minutes).padStart(2, "0");
                    const secondsStr = String(seconds).padStart(2, "0");
                    cooldownCardTimerText.text(
                        `${hoursStr}:${minutesStr}:${secondsStr}`,
                    );
                };

                updateTimer();
                const cooldownCardTimer = setInterval(updateTimer, 1000);
                $this.data("cooldown-timer", cooldownCardTimer);
            }
        });
    }

    /**
     * Opens the select-trade popup when the URL contains valid trade params
     * (trade_id, user_id, token from a trade deep link). No-op if params are
     * missing, token is invalid, or user is trading with themselves.
     */
    async openTradePopupFromUrlParams() {
        const params = new URLSearchParams(window.location.search);
        const tradeId = params.get("trade_id");
        const initiatorId = params.get("user_id");
        const token = params.get("token");

        if (!tradeId || !initiatorId || !token) return;

        const targetUserId = parseInt(tradeId);
        if (this.userId === targetUserId) {
            $(this.elms.snackbarInfoText).text(
                this._data.text_settings?.trade?.snackbar_messages
                    ?.cannot_trade_own_card ??
                "You cannot trade your own card. Please ask the other person to show you a different card to trade.",
            );
            this.toggleSnackbarInfo();
            return;
        }

        const formData = new FormData();
        formData.append("user_id", this.userId.toString());
        formData.append("trade_id", tradeId);
        formData.append("initiator_id", initiatorId);
        formData.append("token", token);
        formData.append("is_with_data", "true");

        const [response] = await bdjs.goAsync(
            bdapi.post("game/validate-trade", formData),
        );

        if (!response?.data?.success) {
            $(this.elms.snackbarInfoText).text(
                response?.data?.data?.message ?? "QR code invalid.",
            );
            this.toggleSnackbarInfo();
            return;
        }

        if (response?.data?.data?.exists) {
            $(this.elms.snackbarInfoText).text(
                this._data.text_settings?.trade?.snackbar_messages
                    ?.already_own_card ??
                "You already have this card. Please ask the other person to show you a different card to trade.",
            );
            this.toggleSnackbarInfo();
            return;
        }

        this.currentColleague = response?.data?.data?.colleague_card;
        this.tradeId = parseInt(tradeId);
        this.initiatorId = parseInt(initiatorId);

        this.toggleSelectTradePopup();
        this.setTradeCardDisabledState();
    }

    /**
     * Handle search input with debouncing.
     */
    onSearchInput(event) {
        const query = $(event.target).val().trim();
        this.searchQuery = query;

        // Clear existing timer
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }

        // Set new timer to debounce the search
        this.searchDebounceTimer = setTimeout(() => {
            this.currentPage = 1; // Reset to first page on new search
            this.reloadCollection();
        }, this.SEARCH_DEBOUNCE_DELAY);
    }

    onApplyFilters() {
        const elms = this.elms;
        const $departmentFilters = $(elms.departmentFilters);
        const $departmentFilterOptions = $departmentFilters.find("label");
        const $rarityFilters = $(elms.rarityFilters);
        const $rarityFilterOptions = $rarityFilters.find("label");
        this.filterRarityIds = $rarityFilterOptions
            .filter(function () {
                return $(this).find("input").prop("checked");
            })
            .map(function () {
                return $(this).find("input").val();
            })
            .get();
        this.filterDepartmentIds = $departmentFilterOptions
            .filter(function () {
                return $(this).find("input").prop("checked");
            })
            .map(function () {
                return parseInt($(this).find("input").val(), 10);
            })
            .get();

        this.currentPage = 1; // Reset to first page when filters change
        this.reloadCollection();
        this.onFilterToggle();
    }

    onResetFilters() {
        const elms = this.elms;
        const $departmentFilters = $(elms.departmentFilters);
        const $rarityFilters = $(elms.rarityFilters);
        $departmentFilters.find("input").prop("checked", false);
        $rarityFilters.find("input[value='all']").prop("checked", true);
        $rarityFilters.find("input[value!='all']").prop("checked", false);
        this.filterDepartmentIds = [];
        this.filterRarityIds = [];
        this.searchQuery = "";
        $(elms.searchInput).val("");
        this.currentPage = 1;
        this.reloadCollection();
        this.onFilterToggle();
    }

    onFilterToggle() {
        const elms = this.elms;
        $(elms.filterDropdownWrapper).toggleClass("is-dropdown-active");
    }

    setGameState() { }

    onOpenColleagueDetailPopup(_, el) {
        const $this = $(el);
        const colleagueId = parseInt($this.data("colleague-id"));
        const colleague = this._data.collection.find(
            (colleague) => colleague.colleague_id === colleagueId,
        );

        if (colleague) {
            this.currentColleague = colleague;
            this.populateCardDetail(colleague);
            this.toggleCardDetailPopup();
        }
    }

    toggleCardDetailPopup() {
        const elms = this.elms;
        const $popup = $(elms.cardDetailPopup);
        const isActive = $popup.hasClass("active");

        if (isActive) {
            // Reset flip state when closing
            this.flipCardToProfile();
        }

        $popup.toggleClass("active");
    }

    onToggleCardDetailDescription() {
        const elms = this.elms;
        $(elms.cardDetailDescriptionOverlay).toggleClass("active");
    }

    onBackButtonClick() {
        const elms = this.elms;
        const isFlipped = $(elms.cardDetailFlipCard).hasClass("is-flipped");

        if (isFlipped) {
            this.flipCardToProfile();
        } else {
            this.toggleCardDetailPopup();
        }
    }

    flipCardToQr() {
        const elms = this.elms;
        $(elms.cardDetailFlipCard).addClass("is-flipped");
        $(elms.cardDetailPopup).addClass("is-qr-view");

        this.updateCardDetailQrCode();
        if (this.qrUpdateInterval) {
            clearInterval(this.qrUpdateInterval);
        }
        this.qrUpdateInterval = setInterval(() => {
            this.updateCardDetailQrCode();
        }, this.QR_UPDATE_INTERVAL_MS);
    }

    flipCardToProfile() {
        const elms = this.elms;
        $(elms.cardDetailFlipCard).removeClass("is-flipped");
        $(elms.cardDetailPopup).removeClass("is-qr-view");

        if (this.qrUpdateInterval) {
            clearInterval(this.qrUpdateInterval);
            this.qrUpdateInterval = null;
        }
        this.qrCodeInstance = null;
    }

    /**
     * Generate QR code data URL for the current colleague (user_id + signed token).
     * @returns {Promise<string|null>} QR code data URL
     */
    async generateCardDetailQrData() {
        const tradeId = this.currentColleague?.colleague_id ?? 0;
        const userId = this.userId;

        if (!tradeId || !userId) {
            return null;
        }

        const formData = new FormData();
        formData.append("trade_id", tradeId.toString());

        const [response] = await bdjs.goAsync(
            bdapi.post("game/qr-token", formData),
        );

        if (!response?.data?.success || !response.data.data?.token) {
            console.warn("Failed to generate trade QR token.");
            return null;
        }

        const qrToken = encodeURIComponent(response.data.data.token);
        return `${CONFIG.siteURL}/?user_id=${userId}&trade_id=${tradeId}&token=${qrToken}`;
    }

    /**
     * Generate and append QR code to the card detail popup flip side.
     */
    async updateCardDetailQrCode() {
        const elms = this.elms;
        const $qrCodeElement = $(elms.cardDetailQrCode);
        const qrCodeElement = $qrCodeElement[0];

        if (!qrCodeElement || !this.currentColleague) return;

        const qrData = await this.generateCardDetailQrData();
        if (!qrData) return;

        qrCodeElement.innerHTML = "";

        const containerWidth = $qrCodeElement.width();
        const availableWidth = containerWidth || 200;
        const qrSize = Math.max(200, Math.min(availableWidth, 200));

        this.qrCodeInstance = new QRCodeStyling({
            width: qrSize,
            height: qrSize,
            type: "svg",
            data: qrData,
            margin: 10,
            image: CONFIG.game.qrLogoURL,
            dotsOptions: {
                color: "#000000",
                type: "square",
                roundSize: false,
            },
            cornersSquareOptions: {
                color: "#000000",
                type: "square",
            },
            cornersDotOptions: {
                color: "#000000",
                type: "square",
            },
            backgroundOptions: {
                color: "#ffffff",
            },
        });

        this.qrCodeInstance.append(qrCodeElement);
    }

    /**
     * Update pagination button disabled states based on current page.
     */
    updatePaginationState() {
        if (!this.pagination) {
            return;
        }

        const elms = this.elms;
        const currentPage = this.pagination.current_page || 1;
        const totalPages = this.pagination.total_pages || 1;
        const $pagination = $(elms.pagination);

        if (!$pagination.length) {
            return;
        }

        // First button
        const $firstBtn = $pagination.find(elms.paginationFirst);
        if (currentPage <= 1) {
            $firstBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $firstBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        // Previous button
        const $prevBtn = $pagination.find(elms.paginationPrev);
        if (currentPage <= 1) {
            $prevBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $prevBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        // Next button
        const $nextBtn = $pagination.find(elms.paginationNext);
        if (currentPage >= totalPages) {
            $nextBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $nextBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        // Last button
        const $lastBtn = $pagination.find(elms.paginationLast);
        if (currentPage >= totalPages) {
            $lastBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $lastBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }
    }

    /**
     * Handle pagination button clicks.
     */
    onPaginationClick(event) {
        const elms = this.elms;
        const $btn = $(event.currentTarget);

        // Don't handle clicks on disabled buttons
        if (
            $btn.hasClass(elms.paginationDisabledClass) ||
            $btn.prop("disabled")
        ) {
            return;
        }

        const action = $btn.data("pagination-action");
        let targetPage = this.currentPage;

        if (action === "first") {
            targetPage = 1;
        } else if (action === "prev") {
            targetPage = Math.max(1, this.currentPage - 1);
        } else if (action === "next") {
            targetPage = Math.min(
                this.pagination?.total_pages || 1,
                this.currentPage + 1,
            );
        } else if (action === "last") {
            targetPage = this.pagination?.total_pages || 1;
        } else {
            // Fallback: try to get page from data-pagination-page
            const page = parseInt($btn.data("pagination-page"), 10);
            if (page && page > 0) {
                targetPage = page;
            }
        }

        if (targetPage !== this.currentPage && targetPage > 0) {
            this.currentPage = targetPage;
            this.reloadCollection();
        }
    }

    /**
     * Handle pagination button clicks in the select-trade popup.
     */
    onTradePaginationClick(event) {
        const elms = this.elms;
        const $btn = $(event.currentTarget);

        if (
            $btn.hasClass(elms.selectTradePaginationDisabledClass) ||
            $btn.prop("disabled")
        ) {
            return;
        }

        const action = $btn.data("pagination-action");
        let targetPage = this.tradeCurrentPage;

        if (action === "first") {
            targetPage = 1;
        } else if (action === "prev") {
            targetPage = Math.max(1, this.tradeCurrentPage - 1);
        } else if (action === "next") {
            targetPage = Math.min(
                this.tradePagination?.total_pages || 1,
                this.tradeCurrentPage + 1,
            );
        } else if (action === "last") {
            targetPage = this.tradePagination?.total_pages || 1;
        } else {
            const page = parseInt($btn.data("pagination-page"), 10);
            if (page && page > 0) {
                targetPage = page;
            }
        }

        if (targetPage !== this.tradeCurrentPage && targetPage > 0) {
            this.tradeCurrentPage = targetPage;
            this.reloadTradePopupCollection();
        }
    }

    /**
     * Fetch collection from API with current filters, search, and pagination.
     */
    async fetchCollection() {
        // Prepare filter arrays - remove 'all' from rarity_levels
        const rarityLevels = this.filterRarityIds.filter((id) => id !== "all");

        const params = {
            page: this.currentPage,
            per_page: this.perPage,
            department_ids: this.filterDepartmentIds,
            rarity_levels: rarityLevels,
            search: this.searchQuery,
        };

        const [response] = await bdjs.goAsync(
            bdapi.post("game/get-collection", params),
        );

        if (response?.data?.success) {
            return response?.data?.data;
        }

        return {
            collection: [],
            stats: {},
            achievements: [],
            pagination: null,
        };
    }

    /**
     * Fetch collection for the select-trade popup with trade-specific filters, search, and pagination.
     */
    async fetchTradeCollection() {
        const rarityLevels = this.tradeFilterRarityIds.filter(
            (id) => id !== "all",
        );

        const params = {
            page: this.tradeCurrentPage,
            per_page: this.perPage,
            department_ids: this.tradeFilterDepartmentIds,
            rarity_levels: rarityLevels,
            search: this.tradeSearchQuery,
        };

        const [response] = await bdjs.goAsync(
            bdapi.post("game/get-collection", params),
        );

        if (response?.data?.success) {
            return response?.data?.data;
        }

        return {
            collection: [],
            pagination: null,
        };
    }

    /**
     * Reload only the select-trade popup grid and pagination with current trade state.
     */
    async reloadTradePopupCollection() {
        const data = await this.fetchTradeCollection();
        this.tradePagination = data.pagination;

        const elms = this.elms;
        const gridTemplate = $("#select-trade-grid-template").html();
        if (!gridTemplate) {
            return;
        }

        const tempData = {
            collection: data.collection,
            pagination: data.pagination,
        };
        const html = compile(gridTemplate, tempData);
        const $newHtml = $(html);
        const $root = $newHtml.hasClass("select-trade-popup-grid-root")
            ? $newHtml
            : $newHtml.find(".select-trade-popup-grid-root");
        const $newGrid = $root.find(elms.selectTradeGrid);
        const $newPagination = $root.find(".select-colleague__pagination");

        const $popup = $(elms.selectTradePopup);
        const $currentGrid = $popup.find(elms.selectTradeGrid);

        if ($newGrid.length && $currentGrid.length) {
            $currentGrid.replaceWith($newGrid);
        }

        // Remove any existing pagination in the popup so we never duplicate
        $popup.find(".select-colleague__pagination").remove();

        if ($newPagination.length) {
            const $gridInDom = $popup.find(elms.selectTradeGrid);
            $gridInDom.after($newPagination);
        }

        this.updateTradePaginationState();
        this.setTradeCardCooldown();
        this.setTradeCardDisabledState();
    }

    /**
     * Re-apply disabled state to the initiator and trade-target cards in the popup
     * (they must not be selectable). Call after grid reload when tradeId/initiatorId are set.
     */
    setTradeCardDisabledState() {
        if (!this.tradeId || !this.initiatorId) {
            return;
        }
        const elms = this.elms;
        const $popup = $(elms.selectTradePopup);
        $popup
            .find(`${elms.selectTradeCard}[data-colleague-id="${this.tradeId}"]`)
            .addClass("disabled");
        $popup
            .find(`${elms.selectTradeCard}[data-colleague-id="${this.initiatorId}"]`)
            .addClass("disabled");
    }

    /**
     * Update trade popup pagination button disabled states based on tradePagination.
     */
    updateTradePaginationState() {
        if (!this.tradePagination) {
            return;
        }

        const elms = this.elms;
        const currentPage = this.tradePagination.current_page || 1;
        const totalPages = this.tradePagination.total_pages || 1;
        const $pagination = $(elms.selectTradePagination);

        if (!$pagination.length) {
            return;
        }

        const disabledClass = elms.selectTradePaginationDisabledClass;

        const $firstBtn = $pagination.find('[data-pagination-action="first"]');
        if (currentPage <= 1) {
            $firstBtn
                .addClass(disabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $firstBtn
                .removeClass(disabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        const $prevBtn = $pagination.find('[data-pagination-action="prev"]');
        if (currentPage <= 1) {
            $prevBtn
                .addClass(disabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $prevBtn
                .removeClass(disabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        const $nextBtn = $pagination.find('[data-pagination-action="next"]');
        if (currentPage >= totalPages) {
            $nextBtn
                .addClass(disabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $nextBtn
                .removeClass(disabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        const $lastBtn = $pagination.find('[data-pagination-action="last"]');
        if (currentPage >= totalPages) {
            $lastBtn
                .addClass(disabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $lastBtn
                .removeClass(disabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }
    }

    /**
     * Reload collection with current filters, search, and pagination.
     */
    async reloadCollection() {
        const collection = await this.fetchCollection();
        this._data.collection = collection.collection;
        this._data.pagination = collection.pagination;
        this.pagination = collection.pagination;

        // Update only the collection grid and pagination
        const elms = this.elms;
        const htmlTemplate = $("#" + this.template).html();
        const tempData = {
            ...this._data,
            collection: collection.collection,
            pagination: collection.pagination,
        };
        const html = compile(htmlTemplate, tempData);

        // Replace only the cards section and pagination
        const $newHtml = $(html);
        const $currentGrid = $(elms.collectionGrid);
        const $newGrid = $newHtml.find(elms.collectionGrid);
        const $currentPagination = $(elms.pagination);
        const $newPagination = $newHtml.find(elms.pagination);

        if ($newGrid.length && $currentGrid.length) {
            $currentGrid.replaceWith($newGrid);
        } else {
            // Fallback: re-render entire page if structure changed
            $(".app").html(html);
            this.updatePaginationState();
            this.setTradeCardCooldown();
            return;
        }

        // Update pagination section
        if ($newPagination.length && $currentPagination.length) {
            $currentPagination.replaceWith($newPagination);
        } else if ($newPagination.length && !$currentPagination.length) {
            // Pagination doesn't exist yet, add it after the grid
            $currentGrid.after($newPagination);
        } else if (!$newPagination.length && $currentPagination.length) {
            // Pagination should be removed
            $currentPagination.remove();
        }

        // Update pagination button states
        this.updatePaginationState();
    }

    /**
     * Populate the card detail display with colleague data.
     */
    populateCardDetail(colleague) {
        const elms = this.elms;
        // Remove existing card-detail-popup__card--* classes before adding new one
        $(elms.cardDetailCard)
            .removeClass(function (_, className) {
                return (className.match(/card-item--\S+/g) || []).join(" ");
            })
            .addClass(`card-item--${colleague.rarity_level}`);
        $(elms.cardDetailDepartment).text(colleague.department.title);
        $(elms.cardDetailAvatar).attr("src", colleague.avatar);
        $(elms.cardDetailName).text(
            colleague.first_name + " " + colleague.last_name,
        );
        $(elms.cardDetailRole).text(colleague.role);

        if (colleague.bizzare_experience.length > 75) {
            $(elms.cardDetailExperience).addClass("is-truncated");
            $(elms.cardDetailExperience).text(
                colleague.bizzare_experience.substring(0, 75) + "...",
            );
        } else {
            $(elms.cardDetailExperience).text(colleague.bizzare_experience);
        }
        $(elms.cardDetailDescriptionFull).text(colleague.bizzare_experience);

        // Populate mini card on the back (QR side)
        this.populateMiniCard(colleague);
    }

    populateMiniCard(colleague) {
        const elms = this.elms;

        $(elms.cardDetailMiniAvatar).attr("src", colleague.avatar);
        $(elms.cardDetailMiniFirstname).text(colleague.first_name);
        $(elms.cardDetailMiniLastname).text(colleague.last_name);
        $(elms.cardDetailMiniDept).text(colleague.department.title);
        $(elms.cardDetailMiniRole).text(colleague.role);

        $(elms.cardDetailMiniCard).attr("data-rarity", colleague.rarity_level);
    }

    // =========================================================================
    // Select Trade Popup Methods
    // =========================================================================

    toggleSelectTradePopup() {
        const elms = this.elms;
        const $popup = $(elms.selectTradePopup);
        $popup.toggleClass("active");

        if ($popup.hasClass("active")) {
            this.tradeSearchQuery = this.searchQuery;
            this.tradeFilterDepartmentIds = [...this.filterDepartmentIds];
            this.tradeFilterRarityIds = [...this.filterRarityIds];
            this.tradeCurrentPage = this.currentPage;
            this.tradePagination = this.pagination;
            $(elms.selectTradeSearchInput).val(this.searchQuery);
            const deptIds = this.filterDepartmentIds;
            $(elms.selectTradeDepartmentFilters)
                .find("input[type='checkbox']")
                .prop("checked", function () {
                    return deptIds.includes(parseInt($(this).val(), 10));
                });
            const rarityIds = this.filterRarityIds;
            $(elms.selectTradeRarityFilters)
                .find("input[type='radio']")
                .prop("checked", function () {
                    const val = $(this).val();
                    return val === "all"
                        ? rarityIds.length === 0 ||
                        (rarityIds.length === 1 && rarityIds[0] === "all")
                        : rarityIds.includes(val);
                });
            this.updateTradePaginationState();
        } else {
            const url = new URL(window.location.href);
            url.searchParams.delete("trade_id");
            url.searchParams.delete("user_id");
            url.searchParams.delete("token");
            if (window.location.href !== url.toString()) {
                window.history.replaceState({}, document.title, url.toString());
            }
        }
    }

    toggleSelectTradeFilter() {
        const elms = this.elms;
        $(elms.selectTradeFilterWrapper).toggleClass("is-dropdown-active");
    }

    /**
     * Handle trade popup search input with debouncing.
     */
    onTradeSearchInput(event) {
        const query = $(event.target).val().trim();
        this.tradeSearchQuery = query;

        if (this.tradeSearchDebounceTimer) {
            clearTimeout(this.tradeSearchDebounceTimer);
        }

        this.tradeSearchDebounceTimer = setTimeout(() => {
            this.tradeCurrentPage = 1;
            this.reloadTradePopupCollection();
        }, this.SEARCH_DEBOUNCE_DELAY);
    }

    onApplyTradeFilters() {
        const elms = this.elms;
        const $departmentFilters = $(elms.selectTradeDepartmentFilters);
        const $departmentFilterOptions = $departmentFilters.find("label");
        const $rarityFilters = $(elms.selectTradeRarityFilters);
        const $rarityFilterOptions = $rarityFilters.find("label");

        this.tradeFilterRarityIds = $rarityFilterOptions
            .filter(function () {
                return $(this).find("input").prop("checked");
            })
            .map(function () {
                return $(this).find("input").val();
            })
            .get();
        this.tradeFilterDepartmentIds = $departmentFilterOptions
            .filter(function () {
                return $(this).find("input").prop("checked");
            })
            .map(function () {
                return parseInt($(this).find("input").val(), 10);
            })
            .get();

        this.tradeCurrentPage = 1;
        this.reloadTradePopupCollection();
        this.toggleSelectTradeFilter();
    }

    onResetTradeFilters() {
        const elms = this.elms;
        $(elms.selectTradeFilterWrapper)
            .find('input[type="checkbox"]')
            .prop("checked", false);
        $(elms.selectTradeFilterWrapper)
            .find('input[type="radio"][value="all"]')
            .prop("checked", true);
        $(elms.selectTradeFilterWrapper)
            .find('input[type="radio"][value!="all"]')
            .prop("checked", false);

        this.tradeFilterDepartmentIds = [];
        this.tradeFilterRarityIds = [];
        this.tradeSearchQuery = "";
        $(elms.selectTradeSearchInput).val("");
        this.tradeCurrentPage = 1;
        this.reloadTradePopupCollection();
        this.toggleSelectTradeFilter();
    }

    onSelectTradeCard(_, el) {
        const elms = this.elms;
        const $card = $(el);

        if ($card.hasClass("disabled") || $card.hasClass("on-cooldown")) {
            return;
        }

        $(elms.selectTradeCard)
            .removeClass("selected")
            .addClass("user-has-selected");
        $card.removeClass("user-has-selected").addClass("selected");

        const deptTitle = $card.data("department") || "";
        const nameParts =
            $card.data("first-name") && $card.data("last-name")
                ? [$card.data("first-name"), $card.data("last-name")]
                : $card
                    .find(".select-colleague__card-name span")
                    .text()
                    .split(" ");
        this.selectedTradeCard = {
            colleague_id: parseInt($card.data("colleague-id"), 10),
            avatar: $card.find(".select-colleague__card-image img").attr("src"),
            first_name: nameParts[0] || "",
            last_name: nameParts.slice(1).join(" ") || "",
            department: { title: deptTitle },
            role: $card.data("role") || "",
            rarity_level: $card.data("rarity") || "lv1",
        };
        this.selectedTradeCardName = `${this.selectedTradeCard.first_name} ${this.selectedTradeCard.last_name}`;
        $(elms.selectTradeConfirm).prop("disabled", false);
    }

    showTradeConfirm() {
        const elms = this.elms;
        const fullName =
            `${this.selectedTradeCard.first_name} ${this.selectedTradeCard.last_name}`.trim() ||
            "#Card";
        const titleTemplate =
            this._data.text_settings?.trade?.confirm_popup?.title ??
            "Are you sure you want to trade {card_name}?";
        const parts = titleTemplate.split(/\{card_name\}/);
        const $title = $(elms.tradeConfirmTitle);
        $title.empty();
        if (parts.length >= 2) {
            $title.append(document.createTextNode(parts[0]));
            $title.append(
                $("<span></span>")
                    .addClass("trade-confirm__card-name")
                    .text(fullName),
            );
            $title.append(document.createTextNode(parts[1]));
        } else {
            $title.text(titleTemplate.replace(/\{card_name\}/g, fullName));
        }
        $(elms.tradeConfirmPopup).addClass("active");
    }

    hideTradeConfirm() {
        const elms = this.elms;
        $(elms.tradeConfirmPopup).removeClass("active");
    }

    async confirmTrade() {
        const elms = this.elms;
        const selectedCardId = this.selectedTradeCard.colleague_id;

        const formData = new FormData();
        formData.append("user_id", this.initiatorId.toString());
        formData.append("trade_id", selectedCardId.toString());

        const [response] = await bdjs.goAsync(
            bdapi.post("game/validate-trade", formData),
        );

        if (response?.data?.data?.exists) {
            $(this.elms.snackbarInfoText).text(
                this._data.text_settings?.trade?.snackbar_messages
                    ?.other_person_already_owns_card ??
                "The person you are trading with already owns this card. Please select a different card to trade with them.",
            );
            this.toggleSnackbarInfo();
            $(elms.selectTradeCard).removeClass("selected user-has-selected");
            $(elms.tradeConfirmPopup).removeClass("active");
            return;
        } else {
            const formData = new FormData();
            formData.append("initiator_id", this.initiatorId.toString());
            formData.append("responder_id", this.userId.toString());
            formData.append(
                "initiator_card_id",
                this.currentColleague.colleague_id.toString(),
            );
            formData.append("responder_card_id", selectedCardId.toString());

            const [response] = await bdjs.goAsync(
                bdapi.post("game/confirm-trade", formData),
            );

            if (response?.data?.success) {
                const url = new URL(window.location.href);
                url.searchParams.delete("trade_id");
                url.searchParams.delete("user_id");
                url.searchParams.delete("token");
                if (window.location.href !== url.toString()) {
                    window.history.replaceState(
                        {},
                        document.title,
                        url.toString(),
                    );
                }

                $(elms.selectTradePopup).removeClass("active");
                $(elms.tradeConfirmPopup).removeClass("active");

                this.lastTradeResult = {
                    achievements: response.data.data.achievements ?? [],
                };
                this.populateTradeSuccessCards();
                $(elms.tradeSuccessPopup).addClass("active");
            } else {
                $(this.elms.snackbarInfoText).text(
                    this._data.text_settings?.trade?.snackbar_messages
                        ?.trade_failed ??
                    "Failed to proceed with trade. Please try again.",
                );
                this.toggleSnackbarInfo();
            }
        }
    }

    async checkTradeStatus() {
        const elms = this.elms;
        const initiatorID = this.userId;
        const initiatorCardID = this.currentColleague.colleague_id;

        const formData = new FormData();
        formData.append("initiator_id", initiatorID.toString());
        formData.append("initiator_card_id", initiatorCardID.toString());

        const [response] = await bdjs.goAsync(
            bdapi.post("game/check-trade-status", formData),
        );

        if (response?.data?.success) {
            this.selectedTradeCard = response.data.data.responder_card;
            this.lastTradeResult = {
                achievements: response.data.data.achievements ?? [],
            };
            this.populateTradeSuccessCards(true);
            $(elms.tradeSuccessPopup).addClass("active");
        } else {
            $(this.elms.snackbarInfoText).text(
                this._data.text_settings?.trade?.snackbar_messages
                    ?.no_card_received ??
                "You have not received any cards from the other person. Please try again.",
            );
            this.toggleSnackbarInfo();
        }
    }

    populateTradeSuccessCards(isInitiator = false) {
        this.reloadCollection();

        const elms = this.elms;
        const tradeOut = isInitiator
            ? this.selectedTradeCard
            : this.currentColleague;
        const tradeIn = isInitiator
            ? this.currentColleague
            : this.selectedTradeCard;
        const dept = (card) =>
            card.department && typeof card.department === "object"
                ? card.department.title
                : card.department || "";

        // Populate received card (the card from other person)
        $(elms.tradeSuccessReceivedAvatar).attr("src", tradeOut.avatar);
        $(elms.tradeSuccessReceivedFirstname).text(tradeOut.first_name);
        $(elms.tradeSuccessReceivedLastname).text(tradeOut.last_name);
        $(elms.tradeSuccessReceivedDept).text(dept(tradeOut));
        $(elms.tradeSuccessReceivedRole).text(tradeOut.role || "");
        $(elms.tradeSuccessReceivedCard).attr(
            "data-rarity",
            tradeOut.rarity_level || "",
        );

        // Populate given card (the card user is giving away)
        $(elms.tradeSuccessGivenAvatar).attr("src", tradeIn.avatar);
        $(elms.tradeSuccessGivenFirstname).text(tradeIn.first_name);
        $(elms.tradeSuccessGivenLastname).text(tradeIn.last_name);
        $(elms.tradeSuccessGivenDept).text(dept(tradeIn));
        $(elms.tradeSuccessGivenRole).text(tradeIn.role || "");
        $(elms.tradeSuccessGivenCard).attr(
            "data-rarity",
            tradeIn.rarity_level || "",
        );
    }

    onTradeSuccessOk() {
        const elms = this.elms;
        $(elms.tradeSuccessPopup).removeClass("active");
        $(elms.cardDetailPopup).removeClass("active");
        this.flipCardToProfile();

        if (this.lastTradeResult?.achievements?.length) {
            this.tradeAchievementIndex = 0;
            $(elms.checkAnimationPopup).addClass("active");

            setTimeout(() => {
                this.onTradeCheckContinue();
            }, 3000);
        } else {
            this.closeTradeSuccess();
        }
    }

    /**
     * Populate achievement popup DOM with the current tradeAchievementIndex (no visibility change).
     */
    populateTradeAchievementContent() {
        const elms = this.elms;
        const achievements = this.lastTradeResult?.achievements;
        const achievementItem = achievements?.[this.tradeAchievementIndex];
        if (!achievementItem) {
            return;
        }
        const firstStep = achievementItem.steps?.[0];
        $(elms.achievementTitle).text(
            (firstStep?.title ?? achievementItem.title) || "",
        );
        const achievementSubtitle =
            this._data?.text_settings?.text_achievement_unlocked ??
            "Prestatie behaald!";
        $(elms.achievementSubtitle).text(achievementSubtitle);
        if (firstStep?.icon) {
            $(elms.achievementImg).attr("src", firstStep.icon);
        }
        $(elms.achievementPoints).text(`+${firstStep.points}`);
    }

    showTradeAchievementPopup() {
        this.populateTradeAchievementContent();
        $(this.elms.achievementAnimationPopup).addClass("active");
    }

    onTradeCheckContinue() {
        if (this.lastTradeResult?.achievements?.length) {
            this.showTradeAchievementPopup();
            return;
        }
        this.closeTradeSuccess();
    }

    onTradeAchievementContinue() {
        const elms = this.elms;
        const $achievement = $(elms.achievementAnimationPopup);
        this.tradeAchievementIndex++;
        const achievements = this.lastTradeResult?.achievements ?? [];

        if (this.tradeAchievementIndex < achievements.length) {
            $achievement.addClass("achievement-animation-popup--switching");
            setTimeout(() => {
                this.populateTradeAchievementContent();
                $achievement.removeClass("achievement-animation-popup--switching");
            }, CollectionPage.ACHIEVEMENT_SWITCH_DURATION_MS);
            return;
        }
        setTimeout(() => {
            this.closeTradeSuccess();
        }, CollectionPage.POPUP_TRANSITION_MS);
    }

    closeTradeSuccess() {
        const elms = this.elms;
        this.lastTradeResult = null;
        this.tradeAchievementIndex = 0;
        $(elms.tradeSuccessPopup).removeClass("active");
        $(elms.cardDetailPopup).removeClass("active");
        $(elms.checkAnimationPopup).removeClass("active");
        $(elms.achievementAnimationPopup).removeClass("active");
        this.flipCardToProfile();
        // Reset trade state
        this.selectedTradeCard = null;
        this.currentColleague = null;
        $(elms.selectTradeCard).removeClass("selected user-has-selected");
        $(elms.selectTradeConfirm).prop("disabled", true);
        $(elms.tradeConfirmPopup).removeClass("active");
    }

    toggleSnackbarInfo() {
        const elms = this.elms;
        $(elms.snackbarInfoWrapper).toggleClass("active");
    }
}
